//
//
//
//
//
//
//


import {mapGetters} from 'vuex';

export default {
  props: ["data"],
  block: 'ImageBlock',
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
    src() {
      let file = this.data.src;
      if (this.isMobile){
        if (this.data.srcMobile){
          file = this.data.srcMobile;
        }
      }

      if (this.data.path){
        return require("@/"+this.data.path+file);
      } else {
        return require("@/assets/imgs/"+file);
      }
    },
    alt() {
      if (typeof this.data.alt !== 'string') {
        if (window.location.href.startsWith('http://www.dev.spotin.com:3000')) {
          console.error(`[Image.vue] \`${this.data.src}\` is missing alt attribute data`);
        }
      }
      return this.data.alt;
    },
  },
  methods: {
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
  }
}



// WEBPACK FOOTER //
// ./components/blocks/Image.vue